import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { CachedTotalWidth as CachedTotalWidth$1 } from './CachedTotalWidth.js';

/** Same idea as CachedDOMMeasurements, but with an indexed array and an imperative way to add items, handy during loops. */

var CachedTotalWidths = /*#__PURE__*/function () {
  function CachedTotalWidths() {
    _classCallCheck(this, CachedTotalWidths);

    this.measurements = [];
  }

  _createClass(CachedTotalWidths, [{
    key: "clearOne",
    value: function clearOne(index) {
      this.measurements[index].clear();
    }
  }, {
    key: "add",
    value: function add(el, index) {
      var cachedWidth = new CachedTotalWidth$1(function () {
        return el;
      });

      if (index !== undefined) {
        this.measurements[index] = cachedWidth;
      } else {
        this.measurements.push(cachedWidth);
      }

      return cachedWidth.value;
    }
  }, {
    key: "get",
    value: function get(index) {
      return this.measurements[index].value;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;

      this.measurements.forEach(function (_item, index) {
        return _this.clearOne(index);
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.measurements.map(function (m) {
        return m.value;
      });
    }
  }]);

  return CachedTotalWidths;
}();

export { CachedTotalWidths };
